import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import CollapsibleRightPanel from "../universal/CollapsibleRightPanel";
import useResponsiveTabsPerSlide from "../universal/useResponsiveTabsPerSlide";
import { AddChurchHooks } from "../../screens/Churches/hooks/Churchhooks";
import LayoutDropdown from "../universal/LayoutDropdown";
import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import LanguageDrawer from "../universal/LanguageDrawer";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { FaInfoCircle } from "react-icons/fa";
import UploadControlsV2 from "../TWG/UploadControlsV2";
import GoogleMapInput from "../../components/MapInput/MapInput";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {fetchChurchByIdRequest } from "../../store/Churches/actions";
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import AllResources from '../../screens/Resources/AllResource';
import AllCarecells from "../../screens/Carcells/allcarcells";
import AllPrograms from "../../screens/Program/AllProgram";
import AllTeam from "../../screens/Teams/AllTeam";
import AllBulletin from '../../screens/Bulletin/allbulletin';
import AllVideos from "../../screens/Videos/AllVideos";
import AllCategories from "../../screens/Categories/AllCategories";
import AllCurriculum from "../../screens/Addcurriculum/CurriculumList.jsx";
// import AllCurriculum from "../../screens/Curriculum/AllCurriculum";

import AllTwg from "../../screens/TWG/AllTwg";
import AllJournals from "../../screens/AddJournal/JournalList";
import Resources from "../../screens/Resources/Resource";
import Carecells from "../../screens/Carcells/carcells"
import Program from '../../screens/Program/Program'
import Teams from "../../screens/Teams/Teams";
import Billetins from "../../screens/Bulletin/bulletin";
import Videos from "../../screens/Videos/Videos";
import Categories from "../../screens/Categories/Categories";
import Curriculum from "../../screens/Curriculum/Curriculum";
import Twg from "../../screens/TWG/Twg";
import Journals from "../../screens/Journals/Journals";
import Galleryfield from "../ImageGallery/galleryfield";
import Campuses from "../Campuses/AllCampus";
import Service from "../Service/serviceTab"
import ReactQuill from "react-quill";
import { AllChurchHooks } from "../../screens/Churches/hooks/Churchhooks";
import ReactModal from "react-modal";
import { ImCross } from "react-icons/im";
import GiveSettingField from "../GiveSetting/settingsfield";
import VideoGalleryField from "../videoGallery/galleryfield";
import Video from "../ChurchVideo/Video";
import AllPlans from "../../screens/Plan/AllPlan";
import SermonPlans from "../../screens/Plan/SermonPlans";
import Circle from "../../screens/Circle/circle.jsx";
import Groups from "../../screens/Groups/group.jsx";
import NotificationsComponent from "../../screens/Notification/userNotificatoin.js";
import ChurchPrayer from "../../screens/Prayers/ChurchesPrayer.js"
// import GalleryPickerField from "../../components/ImageGallery/GalleryPickerField"
import CoverImage from "../CoverImage/CoverImage";
import { readEntityContentDetailsRequest } from "../../store/EntityAnalytics/entityAnalyticsActions";
import { readEntityContentViewsAnalytics } from "../../store/EntityAnalytics/entityAnalyticsApi";
const AddVideosFields = ({ setLoading, data,onClose,church }) => {
  const [selectedChurch, setSelectedChurch] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("church"));
    } catch {
      return null;
    }
  });
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "church") {
        try {
          setSelectedChurch(JSON.parse(e.newValue));
        } catch {
          setSelectedChurch(null);
        }
      }
    };
    const onChurchChange = (e) => {
      if (e?.detail) {
        setSelectedChurch(e.detail);
      }
    };
    window.addEventListener("storage", onStorage);
    window.addEventListener("church:change", onChurchChange);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("church:change", onChurchChange);
    };
  }, []);
  const location = useLocation();
  const stateHasChurch = Object.prototype.hasOwnProperty.call(
    location.state || {},
    "church"
  );
  const isCreateMode =
    location.state?.mode === "create" ||
    (stateHasChurch && location.state?.church === null);
  const resolvedChurch = isCreateMode ? null : church || selectedChurch;
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const rowData = isCreateMode
    ? null
    : stateHasChurch
    ? location.state?.church
    : resolvedChurch;
   const {
    activeTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    setActiveTab,
    setIsLayoutEdit,
    handleInputChange,
    handleFileInputChange,
    handleSave,
    readLanguageData,
    videoInputs,
    videoErrors,
    setVideoErrors,
    setTumbNailUrlsInputs,
    tumbNailUrlsInputs,
    handleChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    isLayoutEdit,
    setEditLayoutIndex,
    setEditTargetLayout,
    editTargetLayout,
    handleLayoutUpdate,
    updateStateWithTranslation,
    languagemeta,
    setLanguagemeta,
    setIsLanguageSave,
    handleSaveLanguage,

    handleSendNotification,
    handleUpdateChurch,
    handleDeleteLayoutFromArray,
    setimageSet,
    churchInputs,
        setChurchInputs

  } = AddChurchHooks(setLoading, data);
  const [showModal, setShowModal] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const [isSideCollapsed, setIsSideCollapsed] = useState(false);

  const [selectedLocation, setSelectedLocation] = useState({
    lat: "",
    lng: "",
    address: "",
  });
  const [tabViews, setTabViews] = useState(null);
  const [tabCount, setTabCount] = useState(null);
  const [viewsSummary, setViewsSummary] = useState(null);

//  const [fetchedData,setfetchedData]=useState();
 const tabs = [
  "Churches","Image Gallery","Cover Image","Video Gallery","Church Video","Circle","Notifications",
  // ,
  "Groups",

  'Plan',
  'Leadership Team',"Resources","Carecells",'Programs', 'Bulletins',"Campuses", "Services",
  "Prayer",
  "Curriculum",
  "Sermon Plans",
  // 'Daily Devotion',
  "Journals"];


  const tabComponents = {
    "Resources": AllResources,
    "Carecells": AllCarecells,
    "Programs": AllPrograms,
    "Leadership Team": AllTeam,
    "Bulletins": AllBulletin,
    "Videos": AllVideos,
    "Categories": AllCategories,
    "Curriculum": AllCurriculum,
    "Daily Devotion": AllTwg,
    "Journals": AllJournals,
    "Image Gallery":Galleryfield,
    "Video Gallery":VideoGalleryField,
    "Campuses":Campuses,
    "Services":Service,
    "Cover Image":CoverImage,
    "Give Setting":GiveSettingField,
    "Church Video":Video,
    "Plan":AllPlans,
    "Circle":Circle,
    "Prayer":ChurchPrayer,
    "Groups":Groups,
    "Sermon Plans":SermonPlans,
    "Notifications":NotificationsComponent

  };
  const SidetabComponents = {
    "Resources": Resources,
    "Carecells": Carecells,
    "Programs": Program,
    "Leadership Team": Teams,
    "Bulletins": Billetins,
    "Videos": Videos,
    "Categories": Categories,
    "Curriculum": Curriculum,
    "Daily Devotion": Twg,
    "Journals": Journals,
    "Image Gallery":Journals,
    "Video Gallery":Journals,
    "Campuses":Journals,
    "Services":Journals,
    "Cover Image":Journals,
    "Give Setting":Journals,
    "Church Video":Journals,
    "Plan":Journals,
    "Sermon Plans":Journals,
    "Prayer":Journals,

    "Circle":Journals,
"Groups":Journals,
"Notifications":Journals




  };

  const contentTypeByTab = {
    "Video Gallery": "videos",
    "Videos": "videos",
    "Curriculum": "curriculums",
    "Plan": "plans",
    "Campuses": "campuses",
    "Carecells": "carecells",
    "Journals": "journals",
    "Leadership Team": "members",
    "Programs": "programs",
    "Services": "services",
    "Bulletins": "bulletins",
  };


 const {fetchAllChurches} = AllChurchHooks();
  useEffect(() => {
    if (isCreateMode) {
      setChurchInputs({
        _id: "",
        church_name: "",
        church_description: "",
        church_tagline: "",
        church_address: "",
        church_email: "",
        church_phone: "",
        church_website: "",
        church_latitude: "",
        church_longitude: "",
        logo_url: "",
        give_url: "",
      });
      setTumbNailUrlsInputs({
        mobileUploadUrl: "",
        webUploadUrl: "",
        tabletUploadUrl: "",
      });
      return;
    }

    const resolvedChurch =
      (stateHasChurch ? location.state?.church : null) || church || selectedChurch;

    let parsedData = resolvedChurch;
    if (!parsedData) {
      try {
        parsedData = JSON.parse(localStorage.getItem("church") || "null");
      } catch (error) {
              }
    }

    if (!parsedData) return;


    setChurchInputs((prev) => ({
      ...prev,
      _id: parsedData._id || "",
      church_name: parsedData.churchName || parsedData.church_name || "",
      church_tagline: parsedData.tagline || parsedData.church_tagline || "",
      church_description: parsedData.description || parsedData.church_description || "",
      church_address: parsedData.address || parsedData.church_address || "",
      church_latitude: parsedData.latitude || parsedData.church_latitude || "",
      church_longitude: parsedData.longitude || parsedData.church_longitude || "",
      church_email: parsedData.contactemail || parsedData.church_email || "",
      church_phone: parsedData.contactphone || parsedData.church_phone || "",
      church_website: parsedData.website || parsedData.church_website || "",
      logo_url: parsedData.logourl || parsedData.logo_url || "",
      give_url: parsedData.giveUrl || parsedData.give_url || "",
    }));

    if (parsedData.logourl) {
      setTumbNailUrlsInputs((prev) => ({
        ...prev,
        webUploadUrl: parsedData.logourl,
      }));
    }
  }, [
    isCreateMode,
    stateHasChurch,
    location.state?.church,
    church,
    selectedChurch,
    setChurchInputs,
    setTumbNailUrlsInputs,
  ]);
  useEffect(() => {
    const churchId = data?.church?._id ;

    if (!churchId) return; // no church ID → skip

    // ✅ Fetch only the specific church
    fetchAllChurches(1, 0, { }, (res) => {

      const churchData = res?.data?.[0]; // since only 1 church is returned

      if (churchData) {

        // ✅ Store all language metas
        if (churchData.languagemetas) {
          setLanguagemeta(churchData.languagemetas);
        }

        // ✅ Find meta for the active language
        const activeLangMeta = churchData.languagemetas?.find(
          (meta) => meta.language_code === activeTab
        );

        // ✅ Merge language-specific values with base church data
        setChurchInputs({
          _id: churchData._id || "",
          church_name:
            activeLangMeta?.churchName || churchData.churchName || "",
          church_tagline:
            activeLangMeta?.tagline || churchData.tagline || "",
          church_description:
            activeLangMeta?.description || churchData.description || "",
          church_address: churchData.address || "",
          church_latitude: churchData.latitude || "",
          church_longitude: churchData.longitude || "",
          church_email: churchData.contactemail || "",
          church_phone: churchData.contactphone || "",
          church_website: churchData.website || "",
          logo_url: churchData.logourl || "",
          give_url:churchData.giveUrl || ""
        });
      } else {
              }
    },churchId);
  }, [data?.church?._id, activeTab ]);





//   const handleLocalChange = (e) => {
//     const { name, value } = e.target;

//     let cleanedValue = value;
//     if (name === "church_description") {
//         // Remove all background-color styles
//         cleanedValue = value.replace(/style="[^"]*background-color[^;"]*;?[^"]*"/gi, '');
//         // Remove empty style attributes
//         cleanedValue = cleanedValue.replace(/style=""/gi, '');
//         // Also remove inline style attributes
//         cleanedValue = cleanedValue.replace(/style='[^']*'/gi, '');
//         // Remove any span tags that might have had background
//         cleanedValue = cleanedValue.replace(/<span[^>]*>/gi, '<span>');
//     }

//     // For phone input, allow only digits and format
//     if (name === "church_phone") {
//         // Remove all non-digit characters first
//         const digitsOnly = value.replace(/\D/g, '');

//         // Format as (XXX) XXX-XXXX
//         let formatted = digitsOnly;
//         if (digitsOnly.length > 3 && digitsOnly.length <= 6) {
//             formatted = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`;
//         } else if (digitsOnly.length > 6) {
//             formatted = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
//         }
//         cleanedValue = formatted;
//     }

//     const nameMap = {
//         church_title: "church_name",
//         church_tagline: "church_tagline",
//         church_description: "church_description",
//         church_address: "church_address",
//         church_latitude: "church_latitude",
//         church_longitude: "church_longitude",
//         church_email: "church_email",
//         church_phone: "church_phone",
//         church_website: "church_website",
//         church_logo_urls: "logourl",
//         give_url: "give_url",
//     };

//     const mappedName = nameMap[name] || name;

//     setChurchInputs((prev) => ({
//         ...prev,
//         [mappedName]: cleanedValue,
//     }));

//     handleChange(e);
//     if (videoErrors && videoErrors[name]) {
//         setVideoErrors(prev => ({
//             ...prev,
//             [name]: null
//         }));
//     }
// };
const handleLocalChange = (e) => {
  const { name, value } = e.target;

  let cleanedValue = value;
  if (name === "church_description") {
    // Remove ALL color-related styles
    cleanedValue = value
      // Remove background-color styles
      .replace(/style="[^"]*background-color[^;"]*;?[^"]*"/gi, '')
      // Remove color styles
      .replace(/style="[^"]*color:[^;"]*;?[^"]*"/gi, '')
      // Remove any style attribute that contains color (more comprehensive)
      .replace(/style="[^"]*(color|background|background-color)[^"]*"/gi, '')
      // Remove empty style attributes
      .replace(/style=""/gi, '')
      // Remove inline style attributes with single quotes
      .replace(/style='[^']*'/gi, '')
      // Remove any span tags that might have had styling (optional - keeps span but removes all styles)
      .replace(/<span[^>]*>/gi, '<span>')
      // Remove any font tags that might bring color
      .replace(/<font[^>]*>/gi, '')
      .replace(/<\/font>/gi, '');

    // Also remove any color-related CSS classes (optional - if you want to be extra thorough)
    cleanedValue = cleanedValue.replace(/class="[^"]*color[^"]*"/gi, '');
  }

  // For phone input, allow only digits and format
  if (name === "church_phone") {
    // Remove all non-digit characters first
    const digitsOnly = value.replace(/\D/g, '');

    // Format as (XXX) XXX-XXXX
    let formatted = digitsOnly;
    if (digitsOnly.length > 3 && digitsOnly.length <= 6) {
      formatted = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`;
    } else if (digitsOnly.length > 6) {
      formatted = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
    }
    cleanedValue = formatted;
  }

  const nameMap = {
    church_title: "church_name",
    church_tagline: "church_tagline",
    church_description: "church_description",
    church_address: "church_address",
    church_latitude: "church_latitude",
    church_longitude: "church_longitude",
    church_email: "church_email",
    church_phone: "church_phone",
    church_website: "church_website",
    church_logo_urls: "logourl",
    give_url: "give_url",
  };

  const mappedName = nameMap[name] || name;

  setChurchInputs((prev) => ({
    ...prev,
    [mappedName]: cleanedValue,
  }));

  handleChange(e);
  if (videoErrors && videoErrors[name]) {
    setVideoErrors(prev => ({
      ...prev,
      [name]: null
    }));
  }
};
    const { tabsViewportRef, tabsPerSlide: max } = useResponsiveTabsPerSlide(tabs.length);
    const [slideIndex, setSlideIndex] = useState(0);
    const [activeTabs, setActiveTabs] = useState("Churches");

    useEffect(() => {
      const tabParam = new URLSearchParams(location.search).get("tab");
      if (!tabParam) return;
      if (tabs.includes(tabParam)) {
        setActiveTabs(tabParam);
        const idx = tabs.indexOf(tabParam);
        setSlideIndex(Math.floor(idx / max));
      }
    }, [location.search]);


    // Calculate number of slides
    const totalSlides = Math.ceil(tabs.length / max);

    const handlePrev = () => {
      setSlideIndex((prev) => Math.max(prev - 1, 0));
    };

    const handleNext = () => {
      setSlideIndex((prev) => Math.min(prev + 1, totalSlides - 1));
    };

    useEffect(() => {
      const activeIndex = tabs.indexOf(activeTabs);
      if (activeIndex >= 0) {
        setSlideIndex(Math.floor(activeIndex / max));
      }
    }, [activeTabs, max]);

    // Determine visible tabs for the current slide
    const start = slideIndex * max;
    const visibleTabs = tabs.slice(start, start + max);
    const ActiveComponent = tabComponents[activeTabs];
    const SideActiveComponent = SidetabComponents[activeTabs];

   const { userInfo } = useSelector((state) => state.user);
   const { galleryList } = useSelector((state) => state.gallery || {});

  const hideUI = location.pathname.includes("addfield")|| userInfo?.roleCode==='17dwer8'||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");

  useEffect(() => {
    if (!resolvedChurch?._id) {
      setViewsSummary(null);
      return;
    }
    let isActive = true;
    (async () => {
      try {
        const res = await readEntityContentViewsAnalytics({
          typeofentity: "1",
          churchObjId: resolvedChurch._id,
        });
        if (!isActive) return;
        const summary =
          res?.summary ||
          (Array.isArray(res?.data) ? res.data[0]?.views : {}) ||
          {};
        setViewsSummary(summary);
      } catch {
        if (isActive) setViewsSummary(null);
      }
    })();
    return () => {
      isActive = false;
    };
  }, [resolvedChurch?._id]);

  useEffect(() => {
    const contentType = contentTypeByTab[activeTabs];
    if (!resolvedChurch?._id) {
      setTabViews(null);
      setTabCount(null);
      return;
    }

    if (activeTabs === "Churches") {
      setTabCount(resolvedChurch?._id ? 1 : 0);
      const entityViews =
        viewsSummary?.entityViews === 0 || viewsSummary?.entityViews
          ? Number(viewsSummary?.entityViews)
          : null;
      setTabViews(entityViews);
      return;
    }

    if (!contentType) {
      setTabViews(null);
      setTabCount(null);
      return;
    }

    const viewsKey = contentType;
    const viewsValue =
      viewsSummary?.[viewsKey] === 0 || viewsSummary?.[viewsKey]
        ? Number(viewsSummary?.[viewsKey])
        : null;
    setTabViews(viewsValue);

    dispatch(
      readEntityContentDetailsRequest(
        {
          contentType,
          typeofentity: "1",
          entityObjId: resolvedChurch._id,
          page: 1,
          limit: 20,
        },
        (res) => {
          const payload = res?.data || {};
          const rows = Array.isArray(payload)
            ? payload
            : Array.isArray(payload?.data)
            ? payload.data
            : [];
          const count = Number(rows?.[0]?.count || 0);
          setTabCount(count);
        }
      )
    );
  }, [activeTabs, resolvedChurch?._id, viewsSummary, dispatch]);

  useEffect(() => {
    if (activeTabs === "Image Gallery") {
      const count = Array.isArray(galleryList) ? galleryList.length : 0;
      setTabViews(null);
      setTabCount(count);
      return;
    }
    if (activeTabs === "Church Video") {
      setTabViews(null);
      if (tabCount === null) setTabCount(0);
    }
  }, [activeTabs, galleryList, tabCount]);
  useEffect(() => {
    setTumbNailUrlsInputs((prev) => ({
      ...prev,
      webUploadUrl: churchInputs.logo_url || "",
    }));
  }, [churchInputs.logo_url]);



const validateURL = (url) => {
  if (!url) return true; // Optional field, empty is valid
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

const validateImageFormat = (fileName) => {
  if (!fileName) return false;
  const validExtensions = ['jpg', 'jpeg', 'png'];
  const extension = fileName.split('.').pop().toLowerCase();
  return validExtensions.includes(extension);
};

  return (
    <div className="flex flex-col md:flex-row h-full w-full min-w-0 flex-1 rounded-2xl overflow-hidden">
      <div className="flex h-full min-w-0 flex-1">
        <LanguageDrawer
          languageData={readLanguageData}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setActiveLanguageDetails={setActiveLanguageDetails}
          languagemeta={languagemeta}
          setIsLanguageSave={setIsLanguageSave}
        />
        <div className="flex h-full min-w-0 flex-1">
          <div className="flex flex-col h-full w-full min-w-0 bg-greyishV2 bg-opacity-50 md:border-l md:border-r border-greyish border-opacity-30 overflow-auto">
            {/* HEADER */}
            <div className={`pt-2 ${hideUI?'h-[124px]':'h-[55px]'} px-4 border-b border-[#28292a] w-full`}>
              <div className="flex gap-4 items-center justify-between">
              <p className="text-white font-semibold text-lg">
              {activeTab === "en"
  ? rowData?.churchName || 'Add Church'
  : rowData?.churchName
    ? `Translate Church to ${activeLanguageDetails?.language_name}`
    : 'Add Church'}

              </p>

              <div className="flex items-center gap-5">
                {activeTab !== "en" && !data?._id && (
                  <p
                    className="flex items-center gap-1 text-greyish text-[11px] font-medium cursor-pointer whitespace-nowrap"
                    onClick={() => updateStateWithTranslation(churchInputs)}

                  >
                    <img src={reload} alt="" /> Auto fill data with google
                    translation
                  </p>
                )}
                {/* {!data?._id && (
                  <button
                    className="text-yellowish bg-blackish font-medium text-[12px] whitespace-nowrap border border-yellowish rounded-xl py-2 px-6"
                    onClick={handleSendNotification}
                  >
                    Send Notification
                  </button>
                )} */}
                {activeTab === "en" ? (
                activeTabs==='Churches' &&
                  <div className="w-full flex items-end justify-end gap-4">
                  {rowData?._id ? (
  <button
    className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
    onClick={async () => {
      try {
        await handleUpdateChurch(churchInputs); // ✅ wait for update
        onClose();                         // ✅ close modal only if success
      } catch (err) {
                // optionally keep modal open
      }
    }}
  >
    Update Church
  </button>
) : (
  <button
    className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
    onClick={async () => {
      try {
        await handleSave({
          onSuccess: () => {
            navigate("/churches/all");
          },
          onClose,
          setChurchData: (savedData) => {
            // This will update the church prop with saved data
            // You need to make sure the parent component can handle this
                      }
        }); // Pass onClose to handleSave
      } catch (err) {
              }
    }}
  >
    Save Church
  </button>
)}
                  </div>
                ) : !data?._id ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSaveLanguage}
                    >
                      Save Language
                    </button>
                  </div>
                ) : null}
              </div>
              </div>
             {hideUI && <div className="relative">

    <div className="flex items-center w-full min-w-0 rounded-lg mt-2">
      {/* Tabs Viewport */}
      <div ref={tabsViewportRef} className="overflow-hidden flex-1 min-w-0">
        {/* Slider track */}
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{
            transform: `translateX(-${slideIndex * 100}%)`,
          }}
        >
          {/* Each slide group */}
          {Array.from({ length: totalSlides }).map((_, slideIdx) => {
            const start = slideIdx * max;
            const slideTabs = tabs.slice(start, start + max);
            return (
              <div
                key={slideIdx}
                className="flex w-full min-w-full flex-shrink-0 gap-3 overflow-hidden"
              >
                {slideTabs.map((tab, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveTabs(tab)}
                    className={`min-w-0 flex-1 truncate px-3 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap ${
                      activeTabs === tab
                        ? "bg-[#F8BA34] text-black"
                        : "text-gray-400 hover:text-black hover:bg-[#F8BA34]/70"
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            );
          })}
        </div>
      </div>

      {/* Arrows stacked vertically */}
      <div className="flex flex-col items-center ml-4 space-y-1">
        <button
          onClick={handleNext}
          disabled={slideIndex >= totalSlides - 1}
          className=" rounded-full transition-colors"
        >
          <FaArrowRight
            className={`text-ms ${
              slideIndex >= totalSlides - 1 ? "text-gray-500" : "text-[#F8BA34]"
            }`}
          />
        </button>

        <button
          onClick={handlePrev}
          disabled={slideIndex === 0}
          className=" rounded-full transition-colors"
        >
          <FaArrowLeft
            className={`text-md ${
              slideIndex === 0 ? "text-gray-500" : "text-[#F8BA34]"
            }`}
          />
        </button>
      </div>
    </div>
</div>
}
            </div>

            {/* TAB CONTENT */}
            <div className="mt-4">
        {activeTabs === "Churches" ? (
          activeTab !== "en" && data?._id ? (
            <div className="flex items-center justify-center text-white gap-1 py-28">
              Church translation in{" "}
              <span className="italic">
                {activeLanguageDetails?.language_name}
              </span>{" "}
              is available for saved churches
            </div>
          ) : (
            <div className="px-4 my-4 h-full">
            <div className="overflow-y-auto overflow-x-hidden px-2">
              <div className="grid md:grid-cols-2 grid-cols-1 grid-rows-1 gap-x-4 gap-y-4 mx-1 w-full">
                {/* FORM FIELDS */}
                {/* Church Title */}
                <div className="md:col-span-2 col-span-1 ">
                  <label className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
                    Church Title *
                    <FaInfoCircle
                      data-tooltip-id="add_church"
                      data-tooltip-content="Enter the Church Title"
                    />
                  </label>
                  <input
                    name="church_title"
                    placeholder="Enter Church Title"
                    type="text"
                    className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 ${
                      videoErrors?.church_title ? 'border border-red-500' : ''
                    }`}
                    value={churchInputs.church_name}
                    onChange={handleLocalChange}
                  />
                  {videoErrors?.church_title && (
                    <p className="text-red-500 text-[10px] left-2">
                      Church Title is a required field
                    </p>
                  )}
                </div>

                {/* Church Tagline */}
                <div className="md:col-span-2 col-span-1">
                  <label className="text-[12px] text-greyish font-medium leading-4">
                    Church Tagline
                  </label>
                  <input
                    name="church_tagline"
                    placeholder="Enter Church Tagline"
                    type="text"
                    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                    value={churchInputs.church_tagline}
                    onChange={handleLocalChange}
                  />
                </div>

                {/* Church Description */}
                <div className="md:col-span-2 col-span-1">
                  <label className="text-[12px] text-greyish font-medium leading-4">
                    Church Description *
                    <span className="text-gray-400 ml-2 text-[10px]">
                      (Minimum 100 characters)
                    </span>
                  </label>
                  <div className="mt-2">
                    <ReactQuill
                      theme="snow"
                      value={churchInputs.church_description}
                      onChange={(value) =>
                        handleLocalChange({
                          target: { name: "church_description", value },
                        })
                      }
                      placeholder="Enter Church Description (minimum 100 characters)"
                      className={`text-white text-[14px] font-medium rounded-md quill-custom ${
                        videoErrors?.church_description ? 'border border-red-500' : ''
                      }`}
                      style={{
                        backgroundColor: "transparent",
                        color: "white",
                      }}
                    />
                    {churchInputs.church_description && (
                      <div className={`text-[10px] mt-1 ${
                        churchInputs.church_description.replace(/<[^>]*>/g, '').length < 100
                          ? 'text-red-500'
                          : 'text-green-500'
                      }`}>
                        {churchInputs.church_description.replace(/<[^>]*>/g, '').length} / 100 characters
                      </div>
                    )}
                  </div>
                  {videoErrors?.church_description && (
                    <p className="text-red-500 text-[10px] left-2">
                      Church Description is required and must be at least 100 characters
                    </p>
                  )}
                </div>

                {/* Google Map Input */}
                <div className="md:col-span-2 col-span-1">
                  <GoogleMapInput
                    defaultLocation={{
                      lat: churchInputs.church_latitude || 40.7128,
                      lng: churchInputs.church_longitude || -74.0060,
                    }}
                    onLocationChange={({ lat, lng, address }) => {
                      setSelectedLocation({ lat, lng, address });
                      handleChange({
                        target: { name: "church_address", value: address },
                      });
                      handleChange({
                        target: { name: "church_latitude", value: lat },
                      });
                      handleChange({
                        target: { name: "church_longitude", value: lng },
                      });
                    }}
                  />
                  {videoErrors?.church_address && (
                    <p className="text-red-500 text-[10px] left-2 mt-1">
                      Location is required
                    </p>
                  )}
                </div>

                {/* Church Address */}
                <div className="md:col-span-2 col-span-1">
                  <label className="text-[12px] text-greyish font-medium leading-4">
                    Church Address *
                  </label>
                  <input
                    name="church_address"
                    placeholder="Enter Church Address"
                    type="text"
                    className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 ${
                      videoErrors?.church_address ? 'border border-red-500' : ''
                    }`}
                    value={selectedLocation?.address || churchInputs.church_address}
                    onChange={handleLocalChange}
                  />
                  {videoErrors?.church_address && (
                    <p className="text-red-500 text-[10px] left-2">
                      Church Address is a required field
                    </p>
                  )}
                </div>

                {/* Latitude & Longitude (hidden) */}
                <div className="md:col-span-1 col-span-1 hidden">
                  <label className="text-[12px] text-greyish font-medium leading-4">
                    Latitude *
                  </label>
                  <input
                    type="text"
                    name="church_latitude"
                    placeholder="Enter Latitude"
                    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                    value={selectedLocation?.lat || churchInputs.church_latitude}
                    onChange={handleLocalChange}
                  />
                </div>
                <div className="md:col-span-1 col-span-1 hidden">
                  <label className="text-[12px] text-greyish font-medium leading-4">
                    Longitude *
                  </label>
                  <input
                    type="text"
                    name="church_longitude"
                    placeholder="Enter Longitude"
                    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                    value={selectedLocation?.lng || churchInputs.church_longitude}
                    onChange={handleLocalChange}
                  />
                </div>

                {/* Contact Email */}
                <div className="md:col-span-1 col-span-1">
                  <label className="text-[12px] text-greyish font-medium leading-4">
                    Contact Email *
                  </label>
                  <input
                    name="church_email"
                    placeholder="Enter Church Email"
                    type="email"
                    className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 ${
                      videoErrors?.church_email ? 'border border-red-500' : ''
                    }`}
                    value={churchInputs.church_email}
                    onChange={handleLocalChange}
                  />
                  {videoErrors?.church_email && (
                    <p className="text-red-500 text-[10px] left-2">
                      {videoErrors.church_email === 'required'
                        ? 'Contact Email is required'
                        : 'Please enter a valid email address'}
                    </p>
                  )}
                </div>

                {/* Contact Phone */}
               {/* Contact Phone */}
<div className="md:col-span-1 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
        Contact Phone
    </label>
    <input
        name="church_phone"
        placeholder="(123) 456-7890"
        type="tel"
        pattern="[0-9]*"
        inputMode="numeric"
        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 ${
            videoErrors?.church_phone ? 'border border-red-500' : ''
        }`}
        value={churchInputs.church_phone}
        onChange={handleLocalChange}
        onBlur={(e) => {
            // Validate on blur
            const phone = e.target.value.replace(/\D/g, '');
            if (phone && phone.length < 10) {
                setVideoErrors(prev => ({
                    ...prev,
                    church_phone: 'Phone number must be at least 10 digits'
                }));
            }
        }}
        maxLength="14" // For formatted number: (123) 456-7890
    />
    {videoErrors?.church_phone && (
        <p className="text-red-500 text-[10px] left-2">
            {videoErrors.church_phone}
        </p>
    )}
    {churchInputs.church_phone && !videoErrors?.church_phone && (
        <p className="text-green-500 text-[10px] left-2 mt-1">
            ✓ Valid phone number format
        </p>
    )}
</div>

                {/* Website */}
                <div className="md:col-span-1 col-span-1">
                  <label className="text-[12px] text-greyish font-medium leading-4">
                    Website
                  </label>
                  <input
                    name="church_website"
                    placeholder="https://example.com"
                    type="url"
                    className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 ${
                      videoErrors?.church_website ? 'border border-red-500' : ''
                    }`}
                    value={churchInputs.church_website}
                    onChange={handleLocalChange}
                    onBlur={() => {
                      if (churchInputs.church_website && !validateURL(churchInputs.church_website)) {
                        setVideoErrors(prev => ({
                          ...prev,
                          church_website: 'Please enter a valid URL (http://, https://)'
                        }));
                      }
                    }}
                  />
                  {videoErrors?.church_website && (
                    <p className="text-red-500 text-[10px] left-2">
                      {videoErrors.church_website}
                    </p>
                  )}
                </div>

                {/* Give URL */}
                <div className="md:col-span-1 col-span-1">
                  <label className="text-[12px] text-greyish font-medium leading-4">
                    Give URL
                  </label>
                  <input
                    name="give_url"
                    placeholder="https://giving.example.com"
                    type="url"
                    className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 ${
                      videoErrors?.give_url ? 'border border-red-500' : ''
                    }`}
                    value={churchInputs.give_url}
                    onChange={(e) => {
                      handleLocalChange(e);
                      // Clear error when user starts typing
                      if (videoErrors?.give_url) {
                        setVideoErrors(prev => ({ ...prev, give_url: null }));
                      }
                    }}
                    onBlur={() => {
                      if (churchInputs.give_url && !validateURL(churchInputs.give_url)) {
                        setVideoErrors(prev => ({
                          ...prev,
                          give_url: 'Please enter a valid URL (http://, https://)'
                        }));
                      }
                    }}
                  />
                  {videoErrors?.give_url && (
                    <p className="text-red-500 text-[10px] left-2">
                      {videoErrors.give_url}
                    </p>
                  )}
                </div>

                {/* Logo Upload */}
                <UploadControlsV2
                  tooltipTitle="Upload Church Logo"
                  className="my-2 col-span-2 mr-1"
                  title="Church Logo *"
                  subtitle="Upload Image (JPG, JPEG, PNG only)"
                  showPreview={true}
                  handleChangeUrl={(event) => {
                    handleInputChange(event, setTumbNailUrlsInputs);
                    // Validate image format
                    if (event.target.files && event.target.files[0]) {
                      const fileName = event.target.files[0].name;
                      if (!validateImageFormat(fileName)) {
                        setVideoErrors(prev => ({
                          ...prev,
                          church_logo_urls: 'Only JPG, JPEG, and PNG formats are allowed'
                        }));
                      } else {
                        setVideoErrors(prev => ({ ...prev, church_logo_urls: null }));
                      }
                    }
                  }}
                  webUploadProgressId="logoUrlAddChurchLogo"
                  handleWebFileUpload={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      if (!validateImageFormat(file.name)) {
                        setVideoErrors(prev => ({
                          ...prev,
                          church_logo_urls: 'Only JPG, JPEG, and PNG formats are allowed'
                        }));
                        return;
                      }
                      setVideoErrors(prev => ({ ...prev, church_logo_urls: null }));
                      handleFileInputChange(
                        setTumbNailUrlsInputs,
                        "logoUrl",
                        file,
                        null,
                        "logoUrlAddChurchLogo",
                        false,
                        "church_logo_urls"
                      );
                    }
                  }}
                  webUploadUrl={tumbNailUrlsInputs?.webUploadUrl}
                  handleWebPreview={() => {
                    setIsImage(true);
                    setShowModal(true);
                    setCurrentUrl(tumbNailUrlsInputs?.webUploadUrl);
                  }}
                  isFieldRequired={videoErrors?.church_logo_urls}
                  requiredMessage={videoErrors?.church_logo_urls || "Church Logo is required"}
                  showMobileUpload={false}
                  showTabletUpload={false}
                  showWebUpload={true}
                />
              </div>
            </div>
          </div>
          )
        ) : ActiveComponent ? (
          <ActiveComponent church={resolvedChurch} />
        ) : (
          <div>Coming soon...</div>
        )}
      </div>

            <Tooltip
              id="add_church"
              className="border border-greyish border-opacity-20"
            />
          </div>
        </div>
      </div>

      {/* SIDE PANEL */}
      <CollapsibleRightPanel title="Stats">
        <CustomTabsV2
          tabHeight="h-[64px]"
          tabsTitleArray={["Stats"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                {resolvedChurch?._id ? (
                  <div className="w-full px-8">
                    {tabViews !== null && (
                      <p>
                        Views : <strong>{tabViews}</strong>
                      </p>
                    )}
                    <p className="mt-2">
                      Count : <strong>{tabCount ?? 0}</strong>
                    </p>
                  </div>
                ) : (
                  <>No stats available</>
                )}
              </div>
            ),
          }}
        />
        {activeTabs !== "Churches" && SideActiveComponent ? (
          <SideActiveComponent />
        ) : null}
      </CollapsibleRightPanel>
  <ReactModal isOpen={showModal} onRequestClose={() => setShowModal(false)}>
        <div className="flex justify-center h-full w-full relative">
          <div
            className="absolute top-0 right-0 cursor-pointer"
            onClick={() => setShowModal(false)}
          >
            <ImCross />
          </div>
          {isImage ? (
            <img className="h-full" src={currentUrl} />
          ) : (
            <video className="h-full" controls autoPlay>
              <source src={currentUrl} />
            </video>
          )}
        </div>
      </ReactModal>
    </div>
  );
};

export default AddVideosFields;
